import { render } from "./PersonalityButton.vue?vue&type=template&id=1f46e4e8&scoped=true&ts=true"
import script from "./PersonalityButton.vue?vue&type=script&lang=ts"
export * from "./PersonalityButton.vue?vue&type=script&lang=ts"

import "./PersonalityButton.vue?vue&type=style&index=0&id=1f46e4e8&scoped=true&lang=scss"

import exportComponent from "/Users/hari/Project/FunctionX/fx-redpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f46e4e8"]])

export default __exports__